module.exports = __webpack_public_path__ + "img/card_bg.ef5849ed.gif";